import React from 'react';
import styled from '@benzinga/themetron';
import { CoreColumn } from './CoreColumn';
import { BlockComponentProps } from '../Block';
import classNames from 'classnames';

export interface CoreColumnsProps {
  block: any;
  campaigns: any;
  getBlock?: (props: BlockComponentProps) => any;
}

export const CoreColumnsBlock: React.FC<CoreColumnsProps> = ({ block, campaigns, getBlock }) => {
  const styles = {
    backgroundColor: block.attrs?.style?.color?.background ?? 'unset',
  };
  const className = block.attrs?.className;

  return (
    <Container className={classNames('wp-block-columns', { [`${className}`]: !!className })} style={styles}>
      {block.innerBlocks?.map((inner_block: any, i: number) => {
        return <CoreColumn block={inner_block} campaigns={campaigns} getBlock={getBlock} key={i} />;
      })}
    </Container>
  );
};

export const Container = styled.div`
  &.wp-block-columns {
    display: flex;
    margin-bottom: 1.75em;
    flex-wrap: wrap;
    padding: 1rem 0;
  }
`;
